<script>
    import { createEventDispatcher } from "svelte";
    import { Input } from "sveltestrap";
    import { getMaxValue, getStepValue } from "./utils/util";
    import l from "./utils/locale";
    const dispatch = createEventDispatcher();
    export let name = "";
    let filter = "";
    let value = 0;
    let valueEffectName = "";
    const onChangeFilter = (e) => {
        value = e.target.value;
        if (name === "effect"){
            setTimeout(() => {
                
                getFilterEffectName()
            }, 110);
        } 
        dispatch("change", { name, value: e.target.value });
    };

    const getFilterEffectName = () => {
        let r = ""
        switch(value) {
            case "1": r = "saturated"; break;
            case "2": r = "blue"; break;
            case "3": r = "silver"; break;
            case "4": r = "neon"; break;
            case "5": r = "emboss"; break;
            case "6": r = "cartoon"; break;
            case "7": r = "blured"; break;
            case "8": r = "black"; break;
            case "9": r = "ripple"; break;
            case "10": r = "sepia"; break;
            case "11": r = "noise"; break;
            case "12": r = "vignette"; break;
            case "13": r = "gray"; break;
            default: r = ""
        }

        valueEffectName = r
        return r
    };
</script>

<div class="app-filter-draw">
    <!-- <img class="app-filter-img noselect" src={`/filter/${name}.png`} alt="" /> -->
    <div
        style={`color:${value > 0 ? "var(--main-color)" : ""}`}
        class="app-filter-label-draw noselect"
    >
        {l[name]}
        {#if (name === "effect" || name === "эффект") && value > 0}
            {value > 0 ? ` (${valueEffectName})` : ""}
        {:else}
            {value > 0 ? ` (${value})` : ""}
        {/if}
    </div>
    <Input
        class="app-filter-range-draw"
        on:input={onChangeFilter}
        {value}
        min={0}
        max={getMaxValue(name)}
        step={getStepValue(name)}
        {name}
        type="range"
    />
</div>
